import React, { useEffect, useState } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { TypeValidationVas } from '../../interfaces/TypeValidationVas/TypeValidationVas'
import { useTypeValidationVas } from '../../hooks/useTypeValidationVas'

interface TypeValidationVasDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  valueKey?: 'typeValidationVasId' | 'name'
  required?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | undefined
}

export const TypeValidationVasDDL: React.FC<TypeValidationVasDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  valueKey = 'typeValidationVasId',
  required = false,
  disabled = false,
  size
}) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const {
    typeValidationVasState: { typeValidationVas },
    getTypeValidationVas
  } = useTypeValidationVas()

  useEffect(() => {
    if (typeValidationVas?.length === 0) {
      getTypeValidationVas()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value < 1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrTypeVas =
    typeValidationVas !== undefined
      ? typeValidationVas.map((option: TypeValidationVas) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {option.name}
          </MenuItem>
        ))
      : []

  return (
    <TextField
      variant={type}
      id='typeValidationVasId'
      name='typeValidationVasId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      disabled={disabled}
      size={size}
      error={hasError}
      helperText={hasError ? 'Seleccionar Tipo de Validación' : undefined}
    >
      <MenuItem key={0} value={0}>
        {'Seleccione Tipo ...'}
      </MenuItem>
      {arrTypeVas}
    </TextField>
  )
}
